import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform, MenuController } from '@ionic/angular';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  templateUrl: './physician-layout.page.html',
  styleUrls: ['./physician-layout.page.scss']
})
export class PhysicianLayoutPage {

  menus: any = [];
  currentUser: any;
  selectedMenu: any;

  constructor(
    private platform: Platform,
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    public menuController: MenuController
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.translate.setDefaultLang(event.lang);
        this.menus = event.translations.PHYSICIANMENUS;
      });

      this.translate.get(['PHYSICIANMENUS']).subscribe((data) => {
        this.menus = data.PHYSICIANMENUS;
      });

      this.authService.onCurrentUserChange.subscribe(user => {
        this.currentUser = user;
      });
    });
  }

  gotoProfile() {
    this.router.navigate(['physician/profile']);
  }
  gotoPhysicianAppointments() {
    this.router.navigate(['/physician/appointments']);
  }
  gotoHome() {
    this.router.navigate(['/physician']);
  }
  signout() {
    this.menuController.close();
    this.authService.logout();
  }
  notification() {
    this.router.navigate(['physician/notification-list']);
  }

}
